// Low-level number utilities with no dependencies, safe for any module to import.

/** Truncate number to specified decimal places without rounding
 * @param num The number to truncate
 * @param decimals The number of decimal places to keep (default is 2)
 * @returns The truncated number without rounding
 */
export const truncateNumber = (num: number, decimals: number = 2): number => {
  if (decimals === 0) {
    return Math.trunc(num);
  }
  const multiplier = 10 ** decimals;
  return Math.trunc(num * multiplier) / multiplier;
};
